import "./RecipesCard.scss";
import Image from "../../../Components/Image/Image";

function RecipesCard({ recipes }) {
  return (
    <div className="recipe-card">
      <Image imgSrc={recipes.image} />
      <div className="recipe-card-info">
        <img className="auther-img" src={recipes.authorImg} alt="" />
        <p className="recipe-title">{recipes.title}</p>
        <p className="recipe-desc">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nobis, a.
        </p>
        <a href="!#" className="view-btn">
          VIEW RECIPE
        </a>
      </div>
    </div>
  );
}

export default RecipesCard;
